import type { Ref } from 'vue';
import {
  computed,
} from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';
import { useConfig } from '@modules/config/composables';
import { buildObjectFromArray } from '@utils/object';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  const { config } = useConfig();

  return computed(() => ({
    admin: {
      partnership_program: {
        conditions: {
          header: 'HEADER',
          create_plan: 'CREATE_PLAN',
          modal_window: {
            remove: 'DIALOG_TITLE',
            remove_question: 'DIALOG_CONTENT',
            delete: 'DIALOG_YES',
            cancel: 'DIALOG_NO',
          },
          create_edit: {
            main_params: {
              form: {
                title: 'FORM_TITLE',
                merchant: 'FORM_MERCHANT',
                type_of_transaction: 'FORM_TYPE_OF_TRANSACTION',
                none: 'FORM_NONE',
                description: 'FORM_DESCRIPTION',
                for_deposits: 'FORM_FOR_DEPOSITS',
                for_withdrawals: 'FORM_FOR_WITHDRAWALS',
                for_deduction: 'FORM_FOR_DEDUCTION',
                for_reward_program: 'FORM_FOR_REWARD_PROGRAM',
                accrual_of_interest_on_the_upper_interval: 'FORM_UPPER_INTERVAL',
                enable_accrual_of_interest_on_the_upper_interval: 'FORM_ENABLE_UPPER_INTERVAL',
                enable_accrual_of_interest_on_the_each_interval: 'FORM_ENABLE_EACH_INTERVAL',
                transferring_a_negative_commission: 'FORM_NEGATIVE_COMMISSION',
                disable_transferring_a_negative_commission: 'FORM_DISABLE_NEGATIVE_COMMISSION',
                enable_transferring_a_negative_commission: 'FORM_ENABLE_NEGATIVE_COMMISSION',
                calculating_profit_method: 'FORM_CALCULATING_PROFIT_METHOD',
                added: 'FORM_ADDED',
                accumulative: 'FORM_ACCUMULATIVE',
                sum_by_products: 'FORM_SUM_BY_PRODUCTS',
                deal_type_version_label: 'FORM_DEAL_TYPE_VERSION_LABEL',
                open_revenue_share_versions_description: 'FORM_OPEN_REVENUE_SHARE_VERSIONS_DESCRIPTION',
                change_revenue_share_version_warning: 'FORM_CHANGE_REVENUE_SHARE_VERSION_WARNING',
                sum_by_merchant_all: {
                  label: 'FORM_SUM_BY_MERCHANT_ALL_LABEL',
                  yes: 'FORM_SUM_BY_MERCHANT_ALL_YES',
                  no: 'FORM_SUM_BY_MERCHANT_ALL_NO',
                },
              },
              header_create: 'HEADER_CREATE',
              header_edit: 'HEADER_EDIT',
            },
            common_button: {
              save: 'COMMON_BUTTONS_SAVE',
              back: 'COMMON_BUTTONS_BACK',
            },
            filters: {
              filter_all_countries: 'FILTER_ALL_COUNTRIES',
              filter_name: 'FILTER_NO_NAME',
              add_new_filter: 'FILTER_ADD_NEW_FILTER',
              countries: 'FILTER_COUNTRIES',
              label_filter_name_input: 'FILTER_LABEL_FILTER_NAME_INPUT',
              modal_window: {
                remove_filter: {
                  title: 'DIALOG_FILTER_TITLE',
                  remove_question: 'DIALOG_FILTER_CONTENT',
                  delete: 'DIALOG_FILTER_YES',
                  cancel: 'DIALOG_FILTER_NO',
                },
              },
              validations: {
                invalid_some_filter: 'VALIDATIONS_INVALID_SOME_FILTER',
                country_required: 'VALIDATIONS_COUNTRY_REQUIRED',
              },
            },
            steps: {
              header: 'STEPS_HEADER',
              condition_items: {
                cpa: {
                  title: 'CONDITION_ITEMS_CPA_TITLE',
                  enter_condition: 'CONDITION_ITEMS_CPA_ENTER_CONDITION',
                  add_condition: 'CONDITION_ITEMS_CPA_ADD_CONDITION',
                },
                validations: {
                  item_is_absent: 'VALIDATIONS_ITEM_IS_ABSENT',
                  can_not_remove_all_items: 'VALIDATIONS_CAN_NOT_REMOVE_ALL_ITEMS',
                  obtained_result_not_unique: 'VALIDATIONS_OBTAINED_RESULT_IS_NOT_UNIQUE',
                  obtained_result_accumulative_not_valid: 'VALIDATIONS_OBTAINED_RESULT_ACCUMULATIVE_NOT_VALID',
                },
              },
              product: {
                rs: buildObjectFromArray(['all'].concat(config.value?.products_list ?? []), 'PRODUCTS.RS.'),
              },
              steps_and_step_items: {
                enter_condition: 'STEPS_ENTER_CONDITION',
                payment_size_empty: 'STEPS_PAYMENT_SIZE_EMPTY',
                step: 'STEPS_STEP',
                add_step: 'STEPS_ADD_STEP',
                tooltip_any: 'STEPS_TOOLTIP_ANY',
                validations: {
                  step_is_absent: 'VALIDATIONS_STEP_IS_ABSENT',
                  invalid_some_product_steps: 'VALIDATIONS_INVALID_SUM_PRODUCT_STEPS',
                  can_not_remove_all_steps: 'VALIDATIONS_CAN_NOT_REMOVE_ALL_STEPS',
                  step_invalid: 'VALIDATIONS_STEP_INVALID',
                  step_accumulative_invalid: 'VALIDATIONS_STEP_ACCUMULATIVE_INVALID',
                },
              },
              modal_window: {
                set_condition: {
                  title: 'SET_CONDITION_TITLE',
                  cancel: 'SET_CONDITION_CANCEL',
                  save: 'SET_CONDITION_SAVE',
                  form: {
                    value: 'SET_CONDITION_FORM_VALUE',
                    payment_column: 'SET_CONDITION_FORM_PAYMENT_COLUMN',
                  },
                },
                set_step_item: {
                  cancel: 'SET_STEP_ITEM_CANCEL',
                  save: 'SET_STEP_ITEM_SAVE',
                  main_title: {
                    edit: 'SET_STEP_ITEM_MAIN_TITLE_EDIT',
                    add: 'SET_STEP_ITEM_MAIN_TITLE_ADD',
                  },
                  form: {
                    obtained_result: 'SET_STEP_ITEM_FORM_OBTAINED_RESULT',
                    condition_for_comparison: 'SET_STEP_ITEM_MAIN_TITLE_EDIT_CONDITION_FOR_COMPARISON',
                    desired_value: 'SET_STEP_ITEM_MAIN_TITLE_EDIT_DESIRED_VALUE',
                  },
                },
              },
            },
          },
        },
      },
    },
  }));
}
